export default "__VITE_ASSET__DPHSmnqZ__"